// src/pages/setting/settingSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { settingApi } from './settingApi';

import type { ITeamItem, IUserItem } from '../setting.types';

interface SettingState {
  teamList: { list: ITeamItem[]; total: number } | null;
  userList: { list: IUserItem[]; total: number } | null;
  userProfileDtl: any | null;
  activeSubscription: any; // 👈 changed
}

const initialState: SettingState = {
  teamList: null,
  userList: null,
  userProfileDtl: null,
  activeSubscription: null, // 👈
};

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    setTeamList: (state, action: PayloadAction<{ list: ITeamItem[]; total: number }>) => {
      state.teamList = action.payload;
    },
    setActiveSubscription: (state, action: PayloadAction<any>) => {
      state.activeSubscription = action.payload;
    },
    resetSettingState: () => initialState, // ✅ reset everything
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        settingApi.endpoints.getTeamList.matchFulfilled,
        (state, action: PayloadAction<{ list: ITeamItem[]; total: number }>) => {
          state.teamList = action.payload;
        }
      )
      .addMatcher(
        settingApi.endpoints.getUserList.matchFulfilled,
        (state, action: PayloadAction<{ list: IUserItem[]; total: number }>) => {
          state.userList = action.payload;
        }
      )
      .addMatcher(settingApi.endpoints.getUserDtl.matchFulfilled, (state, action) => {
        state.userProfileDtl = action.payload;
      });
  },
});

export const { setTeamList, setActiveSubscription, resetSettingState } = settingSlice.actions;
export default settingSlice.reducer;
